
import persist from './persist';

export const local = {};

export const global = {
	persist
};

export {
	// someMixin
	persist
};

export default {
	// someMixin
	persist
};



// WEBPACK FOOTER //
// ./src/vue/mixins/index.js